/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Combobox,
  Box,
  Text,
  VisuallyHidden,
  SSRProvider,
} from "@fuegokit/react";
import { AkChevronDownIcon } from "@fuegokit/fuegoicons-react";
import { useIsSSR } from "react-aria";

import {
  StyledCombobox,
  StyledComboboxButton,
  StyledComboboxInput,
  StyledComboboxItem,
  StyledComboboxListbox,
  StyledComboboxPopover,
  StyledComboboxHeader,
  StyledComboboxSection,
  StyledComboboxText,
  StyledComboboxLabel,
  CustomItem,
  StyledComplexComboboxItem,
} from "../StoryStyles/ComboboxStyles";

const StyledComboboxExample = () => {
  const [domLoaded, setDomLoaded] = useState(false);
  useEffect(() => {
    setDomLoaded(true);
  }, []);

  return (
    <Box>
      {domLoaded && (
        <StyledCombobox>
          <Combobox.Label>Favorite ice cream</Combobox.Label>
          <Box
            className="my-combobox-container"
            sx={{
              display: "flex",
            }}
          >
            <StyledComboboxInput />
            <StyledComboboxButton>
              <VisuallyHidden>Menu</VisuallyHidden>
              <AkChevronDownIcon />
            </StyledComboboxButton>
          </Box>
          <StyledComboboxPopover>
            <StyledComboboxListbox>
              <StyledComboboxItem>Chocolate</StyledComboboxItem>
              <StyledComboboxItem>Mint</StyledComboboxItem>
              <StyledComboboxItem>Strawberry</StyledComboboxItem>
              <StyledComboboxItem>Vanilla</StyledComboboxItem>
            </StyledComboboxListbox>
          </StyledComboboxPopover>
        </StyledCombobox>
      )}
    </Box>
  );
};
export default StyledComboboxExample;
